<template>
  <v-container fluid class="px-8" v-if="showContent">
    <v-list dense>
      <v-card outlined tile>
        <v-subheader class="background font-weight-bold subtitle-2">
          <v-breadcrumbs
            :items="breadcrumbs"
            event
            class="mx-n4"
          ></v-breadcrumbs>
        </v-subheader>
      </v-card>
      <v-card outlined tile class="mb-4 pb-3">
        <v-card-text>
          <router-view id="main-content" class="mb-3" />
        </v-card-text>
      </v-card>
    </v-list>
  </v-container>
  <v-container fill-height fluid v-else>
    <v-row align="center" justify="center">
      <v-spacer></v-spacer>
      <v-col justify="center">{{ emptyContent }}</v-col>
      <v-spacer></v-spacer>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    showContent: {
      type: Boolean,
      default: false,
    },
    emptyContent: {
      type: String,
    },
    breadcrumbs: {
      required: true,
      type: Array,
    },
  },
};
</script>

<style scoped lang="scss">
.theme--light.v-card {
  border: thin solid black;
  margin-bottom: -1px;
}
</style>
